import React from 'react';
import PropTypes from 'prop-types';

import {Dialog, DialogContent, DialogTitle, Box, Button, Grid, Typography} from 'views/components';
import {Translate, translate} from 'views/module';

const AcceptCancelRequest = (props) => {
  const {closeModel, event, onCancelEvent} = props;
  const [isSaving, setIsSaving] = React.useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    setIsSaving(true);

    const cancellation = event.caregiverUpdates.find((update) => update.type === 'requestCancel');
    const rejectionReason = cancellation.data.reason || translate('eventList.eventDetail.EventTimelineSection.ShiftCancelled.NoReason');

    const reasonForException ={
      description: {
        blob: rejectionReason,
        editorType: 'MARKDOWN',
      },
    };

    await onCancelEvent(
        event.clientRn,
        event.eventRn,
        reasonForException,
        () => {
          closeModel(true);
        },
    );
  };

  const onClose = () => {
    closeModel(false);
  };

  return (
    <Dialog onClose={onClose} open={true} maxWidth="sm" fullWidth>
      <DialogTitle onClose={onClose}>
        <Translate expression='eventList.AcceptCancelDialog.Title'/>
      </DialogTitle>
      <DialogContent >
        <Grid size={12}>
          <Typography variant="body2" color="text.secondary">
            <Translate expression='eventList.AcceptCancelDialog.Description'/>
          </Typography>
        </Grid>
      </DialogContent>
      <Box sx={{display: 'flex', justifyContent: 'flex-end', gap: 1, p: 2}}>
        <Button variant="outlined" onClick={onClose}>
          <Translate expression="generic.Cancel" />
        </Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={isSaving}
        >
          <Translate expression="generic.Confirm" />
        </Button>
      </Box>
    </Dialog>
  );
};

AcceptCancelRequest.propTypes = {
  closeModel: PropTypes.func.isRequired,
  event: PropTypes.object.isRequired,
  onCancelEvent: PropTypes.func.isRequired,
};

export default AcceptCancelRequest;
